/**
 * Cart utility functions and constants
 */

export const CART_STORAGE_KEY = 'keyprog_cart';
